import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("kbd", {
        "data-slot": "kbd-group",
        class: _normalizeClass($setup.cn('inline-flex items-center gap-1', $setup.props.class))
    }, [
        _renderSlot(_ctx.$slots, "default")
    ], 2 /* CLASS */));
}
